import { securedAxios } from "../lib/axios";
export default {
  namespaced: true,
  state: {
    unidadeMedida: [],
  },
  mutations: {
    carregarUnidadeMedida(state, unidades) {
      state.unidadeMedida = unidades;
    },
    buscarUnidadeMedida(state, response) {
      state.unidadeMedida = response;
    },
  },
  actions: {
    async listar({ commit }) {
      try {
        const response = await securedAxios.get("/unidademedida");

        commit("carregarUnidadeMedida", response.data);
        return Promise.resolve(true);
      } catch (err) {
        commit("carregarUnidadeMedida", []);
        return Promise.reject(err);
      }
    },
    buscar(context, aFiltro) {
      try {
        var filtro = aFiltro.filtro ? aFiltro.filtro : "";
        var valor = aFiltro.valor ? aFiltro.valor : "";

        securedAxios
          .get("/unidademedida?" + filtro + "=" + valor)
          .then((response) =>
            context.commit("buscarUnidadeMedida", response.data)
          );

        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async gravar(context, UnidadeMedidaInfo) {
      try {
        var id = UnidadeMedidaInfo.id;

        if (id == "") {
          var infoNovo = {
            id: this.state.fakeID,
            descricao: UnidadeMedidaInfo.descricao,
            codigo: UnidadeMedidaInfo.codigo,
            actions: {
              canView: true,
              canEdit: true,
              canDelete: true,
            },
          };
          await securedAxios.post("/unidademedida", infoNovo);
        } else {
          var infoAltera = {
            descricao: UnidadeMedidaInfo.descricao,
            codigo: UnidadeMedidaInfo.codigo,
            actions: {
              canView: true,
              canEdit: true,
              canDelete: true,
            },
          };
          await securedAxios.put("/unidademedida/" + id, infoAltera);
        }

        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async deletar(context, id) {
      try {
        await securedAxios.delete("/unidademedida/" + id.id);
        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async carregarUnidadeMedida(context, id) {
      try {
        const response = await securedAxios.get("/unidademedida/" + id);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async carregarUnidadesMedidas() {
      return securedAxios.get("/unidademedida");
    },
  },
};
